import type {
  CompleteDocumentUploadResponse,
  DocumentResponse,
  RequestDocumentUploadRequest,
  RequestDocumentUploadResponse
} from '@tandemone/types'

import { api } from '@/api/client'

export async function requestDocumentUpload(
  body: RequestDocumentUploadRequest
): Promise<RequestDocumentUploadResponse> {
  const response = await api.post<RequestDocumentUploadResponse>(
    '/v1/documents',
    body
  )
  return response.data
}

export async function uploadDocumentContent(
  documentId: string,
  file: File
): Promise<void> {
  await api.put(`/v1/documents/${documentId}/content`, file, {
    headers: { 'Content-Type': file.type }
  })
}

export async function completeDocumentUpload(
  documentId: string
): Promise<CompleteDocumentUploadResponse> {
  const response = await api.post<CompleteDocumentUploadResponse>(
    `/v1/documents/${documentId}/complete`
  )
  return response.data
}

export async function getDocument(
  documentId: string,
  signal?: AbortSignal
): Promise<DocumentResponse> {
  const response = await api.get<DocumentResponse>(
    `/v1/documents/${documentId}`,
    { signal }
  )
  return response.data
}

export async function deleteDocument(documentId: string): Promise<void> {
  await api.delete(`/v1/documents/${documentId}`)
}
